// export const PULLER_TOP_SPACING = 8;
export const PULLER_HEIGHT = 3;
export const PULLER_WIDTH = 36;
// const LAYOUT_TOP_SPACING = 8;
export const MODAL_LAYOUT_HORIZONTAL_SPACING_DESKTOP = 6;
export const MODAL_MOBILE_BREAKPOINT_THRESHOLD = 'sm';
export const MODAL_MAX_WIDTH_DESKTOP = 434;
export const MODAL_PULLER_VERTICAL_SPACING = 6;
export const name = 'ModalLayout';
import { cssToken } from '@cp/ui';

export const Tokens = {
  PullerColor: cssToken(name, ['color', 'puller']),
  HeaderIconTop: cssToken(name, ['dimension', 'top']),
  Radius: cssToken(name, ['radius']),
  PaperColor: cssToken(name, ['color', 'paper']),
  PaddingTop: cssToken(name, ['padding', 'top']),
  PaddingBottom: cssToken(name, ['padding', 'bottom']),
  PaddingX: cssToken(name, ['padding', 'x']),
  ContainerOffset: cssToken(name, ['container', 'offset']),
  ContainerWidth: cssToken(name, ['container', 'width']),
};

export enum ModalLayoutVariant {
  primary = 'primary',
  drawerRight = 'drawerRight',
}
